import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import { safeRest, noop } from '../../utils/functions.js';
import { CONTENT_TYPE } from './constants.js';
import SubNavItem from './SubNavItem.js';

var _excluded = ["id", "as", "label", "itemKey", "to", "onClick", "children"];
var SubNavDropdown = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    as = _ref.as,
    label = _ref.label,
    itemKey = _ref.itemKey,
    to = _ref.to,
    onClick = _ref.onClick,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var safeProps = safeRest(rest);
  return /*#__PURE__*/React.createElement(SubNavItem, _extends({
    id: id,
    as: as,
    label: label,
    itemKey: itemKey,
    contentType: CONTENT_TYPE.DROPDOWN,
    to: to,
    onClick: onClick,
    ref: ref
  }, safeProps), children);
});
process.env.NODE_ENV !== "production" ? SubNavDropdown.propTypes = {
  /** id for SubNavDropdown */
  id: PropTypes.string,
  /** type of component to use as nav item (e.g. Link from react-router-dom, button, etc.) */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** label for dropdown */
  label: PropTypes.node,
  /** unique key used for item selection */
  itemKey: PropTypes.string.isRequired,
  /** url (by default maps to href) or url/object/function (when using Link from react-router-dom) */
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]),
  /** onClick handler for item */
  onClick: PropTypes.func,
  /** 1 or more SubNavItem components for dropdown */
  children: PropTypes.node.isRequired
} : void 0;
SubNavDropdown.defaultProps = {
  id: undefined,
  as: 'a',
  label: undefined,
  to: undefined,
  onClick: noop
};
process.env.NODE_ENV !== "production" ? SubNavDropdown.displayName = 'SubNavDropdown' : void 0;
var SubNavDropdown$1 = SubNavDropdown;

export { SubNavDropdown$1 as default };
